// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3zx9V","notes":"Notes_notes__34UAu","note":"Notes_note__1DRRn","markdown":"Notes_markdown__5scst"};